import GuruttoAi from './GuruttoAi'

export default GuruttoAi
